import {
    GALLERY_ADD_PICTURES_TO_ROOT
} from './permissions';

// These permissions will be checked for truthiness even if user is admin or owner of project.
export const BUSINESS_EXPLICIT_PERMISSIONS = [
    GALLERY_ADD_PICTURES_TO_ROOT,
];